import { VerifiedUserOutlined as VerifiedIcon } from '@mui/icons-material';

const VerifiedOutlined = (): JSX.Element => <VerifiedIcon fontSize="inherit" />;

export default VerifiedOutlined;
